import React, { useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
	label: {
		color: theme.palette.grey[600],
		minHeight: 18,
		maxWidth: 550,
	},
	value: {
		color: theme.palette.text.primary,
		minHeight: 18,
		maxWidth: 550,
	},
	container: {
		marginBottom: "16px",
	},
}))

const LabelValue = (props) => {
	const classes = useStyles()
	const { label, value, loading, valueStyle } = props
	return (
		<Grid item xs={12} className={classes.container}>
			<Typography variant="body2" component="p" className={classes.label}>
				{label}
			</Typography>
			{!loading ? (
				<Typography variant="body2" component="p" className={valueStyle || classes.value}>
					{value || (value == 0 ? value : "—")}
				</Typography>
			) : (
				<Skeleton width="100px" />
			)}
		</Grid>
	)
}

export default LabelValue
